<dx-popup #dlgSaleItemEditor [width]="804" height="auto" [minWidth]="800" [minHeight]="600" [showTitle]="true"
    title="Client Details" [resizeEnabled]=false (onShowing)="onShowing($event)" (onHiding)="onHiding($event)"
    [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false" [animation]="null">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="SaveButtonOptions">
    </dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>    

    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view width="100%" height="100%" [direction]="vertical" [showScrollbar]="always">
            <dx-form *ngIf="client" [showColonAfterLabel]="false" [formData]="client">
                <!-- (onEditorPreparing)="onEditorPreparing($event)" -->
                <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
                    <dxi-item dataField="Active" editorType="dxCheckBox">
                        <dxo-label text="Active?">
                        </dxo-label>
                    </dxi-item>
                    <dxi-item dataField="Title" [colSpan]="2" [editorOptions]="FirstLetterUpperCaseEditorOptions10"></dxi-item>
                    <dxi-item dataField="FirstName" [editorOptions]="FirstLetterUpperCaseEditorOptions">
                        <dxi-validation-rule type="required" trim="true"
                            [message]="constants.RequiredFieldMessage('client','first name')">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="MiddleNames" [editorOptions]="FirstLetterUpperCaseEditorOptions"></dxi-item>
                    <dxi-item dataField="LastName" [editorOptions]="FirstLetterUpperCaseEditorOptions">
                        <dxi-validation-rule type="required" trim="true"
                            [message]="constants.RequiredFieldMessage('client','last name')">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="MobileTelephone" [isRequired]="mobileRequired && client.Id === -1" template="mobileTelephoneTemplate">
                        <dxi-validation-rule type="custom" [validationCallback]="validateMobileIfRequired"
                            [message]="constants.RequiredFieldMessage('client','mobile number')">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="custom" [validationCallback]="validateMobileFormat"
                            [message]="'Please enter a valid mobile telephone number.'">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item #EmailCtl dataField="EmailAddress" [colSpan]=1
                        [isRequired]="emailRequired && client.Id === -1">
                        <dxi-validation-rule type="custom" [message]="constants.EmailValidationMessage" [validationCallback]="validateEmailFormat">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="async" [message]="constants.UniqueEmailValidationMessage"
                            [validationCallback]="EmailAddressValidation">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="custom" [validationCallback]="validateEmailIfRequired"
                            [message]="constants.RequiredFieldMessage('client','email address')">
                        </dxi-validation-rule>
                    </dxi-item>                
                    <dxi-item dataField="DateOfBirth" label="Date of Birth" [isRequired]="DOBRequired && client.Id === -1">
                        <app-date-selector [(value)]="client.DateOfBirth" [min]="minDOB" [max]="maxDOB"
                            [showClear]="!(DOBRequired && client.Id === -1)"
                            [required]="DOBRequired && client.Id === -1 && dirty">
                        </app-date-selector>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="tabbed" [colSpan]="2" [colCount]="2">
                    <dxo-tab-panel-options [deferRendering]="false" [showNavButtons]="true" [selectedIndex]="selectedTabIndex">
                    </dxo-tab-panel-options>   
                    <dxi-tab title=" Details" colCount=4>
                        <dxi-item dataField="Gender" dataType="string" editorType="dxSelectBox" [colSpan]="2"
                            [editorOptions]="{showClearButton:true, dataSource:[{Text:'Female', Value:'F'},{Text:'Male',Value:'M'},{Text:'Unspecified', Value:'U'}], valueExpr:'Value', displayExpr:'Text'}">
                            <dxo-label text="Gender">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="SkinTypeId" dataType="number" editorType="dxSelectBox" [colSpan]="2"
                            [isRequired]="skinTypeRequired && client.Id === -1"
                            [editorOptions]="{showClearButton:true, dataSource:skinTypeLookup, valueExpr:'Value', displayExpr:'Text'}">
                            <dxo-label text="Skin Type">
                            </dxo-label>
                            <dxi-validation-rule type="custom" [validationCallback]="validateSkinTypeIfRequired"
                                [message]="constants.RequiredFieldMessage('client','skin type')">
                            </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="ClientNumber" [colSpan]="2">
                        </dxi-item>
                        <dxi-item dataField="BranchEnrolled" dataType="number" editorType="dxSelectBox" [colSpan]="2"
                            [editorOptions]="{dataSource:branchLookup, valueExpr:'Value', displayExpr:'Text', disabled: true}">
                            <dxo-label text="Enrolled At">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="PreSessionDelay" editorType="dxSelectBox" dataType="number" [colSpan]="2"
                            [editorOptions]="{dataSource:SessionDelayData, valueExpr:'Value', displayExpr:'Text', placeholder:'Use system defaults', showClearButton:true}">
                            <dxo-label text="Pre-Session Delay (Mins)">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="PostSessionDelay" editorType="dxSelectBox" dataType="number" [colSpan]="2"
                            [editorOptions]="{dataSource:SessionDelayData, valueExpr:'Value', displayExpr:'Text', placeholder:'Use system defaults', showClearButton:true}">
                            <dxo-label text="Post-Session Delay (Mins)">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="AllowOnlineBooking" editorType="dxCheckBox" dataType="boolean" [colSpan]="2">
                            <dxo-label text="Allow Online Reservations?">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="IdChecked" editorType="dxCheckBox" dataType="boolean" [editorOptions]="{ disabled:client.IdCheckedDateTime}">
                          <dxo-label text="ID Checked?"></dxo-label>
                          <dxi-validation-rule *ngIf="idCheckRequired" type="required" trim="true"
                            [message]="constants.RequiredFieldMessage('client','id check')">
                        </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item itemType="simple" *ngIf="client.IdCheckedDateTime" style="padding-left: 24px; padding-top: 6px;">{{client.IdCheckedDateTime | date: 'dd/MMM/yyyy'}}</dxi-item>
                    </dxi-tab>

                    <dxi-tab title="Urgent Notes">
                        <dxi-item dataField="UrgentNotes" [colSpan]=2 editorType="dxTextArea"
                            [editorOptions]="{height:'174px'}">
                            <dxo-label visible="false" text=" "></dxo-label>
                        </dxi-item>
                    </dxi-tab>

                    <dxi-tab  title="Photo" [colCount]="1">
                        <dxi-item dataField="Photo" template="clientPhotoTemplate">
                            <dxo-label [visible]=false>></dxo-label>
                        </dxi-item>                        
                    </dxi-tab>

                    <dxi-tab  title="Address" [colCount]="2">
                        <dxi-item dataField="Address1" [colSpan]=2 [editorOptions]='ctlAddress'>
                            <dxo-label text="Street">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="Address2" [colSpan]=2>
                            <dxo-label text="Sub-Locality">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="Address3">
                            <dxo-label text="Locality">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="Address4">
                            <dxo-label text="Town or City">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="Address5">
                            <dxo-label text="County">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="PostalCode">
                            <dxo-label text="Postcode">
                            </dxo-label>
                            <dxi-validation-rule type="pattern" [pattern]="constants.PostcodePattern"
                                [message]="constants.PostcodeValidationMessage"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                    </dxi-tab>

                    <dxi-tab title="Credits" [colCount]="2">
                        <app-client-credit-history [clientId]="client.Id"></app-client-credit-history>
                    </dxi-tab>

                    <dxi-tab title="Products" [colCount]="2">
                        <app-client-product-history [clientId]="client.Id"></app-client-product-history>
                    </dxi-tab>

                    <dxi-tab title="Future Appointments" [colCount]="2">
                        <app-client-future-appointments [clientId]="client.Id"></app-client-future-appointments>
                    </dxi-tab>

                    <dxi-tab title="Contact" colCount=2>
                        <dxi-item dataField="HomeTelephone" [colSpan]="2" [editorOptions]='ctlHomeTelephone'>
                            <dxi-validation-rule type="pattern" [pattern]="constants.TelephonePattern"
                                [message]="constants.TelephoneValidationMessage">
                            </dxi-validation-rule>
                        </dxi-item>

                        <dxi-item #ContactByEmailCtl dataField="ContactByEmail" editorType="dxCheckBox"
                            dataType="boolean" [editorOptions]="{ disabled: disableEmailAddress}">
                            <dxo-label text="Receive Email Marketing">
                            </dxo-label>
                        </dxi-item>

                        <dxi-item dataField="ContactByMobileTelephone" editorType="dxCheckBox" dataType="boolean"
                            [editorOptions]="{ disabled:disableMobileTelephone}">
                            <dxo-label text="Receive SMS Marketing">
                            </dxo-label>
                        </dxi-item>

                        <dxi-item dataField="ContactByAddress" editorType="dxCheckBox" dataType="boolean"
                            [editorOptions]="{ disabled:disableAddress}">
                            <dxo-label text="Contact By Address?">
                            </dxo-label>
                        </dxi-item>
                        <dxi-item dataField="ContactByHomeTelephone" editorType="dxCheckBox" dataType="boolean"
                            [editorOptions]="{ disabled:disableHomeTelephone}">
                            <dxo-label text="Contact By Home Telephone?">
                            </dxo-label>
                        </dxi-item>
                    </dxi-tab>

                    <dxi-tab title="Disclaimers">
                        <app-client-disclaimer-history [clientId]="client.Id"></app-client-disclaimer-history>
                    </dxi-tab>

                    <dxi-tab title="Screening Questions">
                        <app-client-screening-questions [clientId]="client.Id"></app-client-screening-questions>
                    </dxi-tab>
                    
                    <dxi-tab title="Emergency Info">
                        <dxi-item dataField="EmergencyInfo" [colSpan]=2 editorType="dxTextArea"
                            [editorOptions]="{height:'174px'}">
                            <dxo-label visible="false" text=" "></dxo-label>
                        </dxi-item>
                    </dxi-tab>

                    <dxi-tab title="Notes">
                        <dxi-item dataField="Notes" [colSpan]=2 editorType="dxTextArea"
                            [editorOptions]="{height:'174px'}">
                            <dxo-label visible="false" text=" "></dxo-label>
                        </dxi-item>
                    </dxi-tab>

                    <dxi-tab *ngIf="FFClientDiscounts===true" title="Discounts" [colCount]="2">
                        <dxi-item dataField="ProductDiscount" dataType="number" editorType="dxNumberBox" [editorOptions]="discountEditorOptions">
                            <dxo-label Text="% Discount on Products"></dxo-label>
                        </dxi-item>               
                        <dxi-item itemType="empty"></dxi-item>
                        <dxi-item dataField="SessionDiscount" dataType="number" editorType="dxNumberBox" [editorOptions]="discountEditorOptions">
                            <dxo-label Text="% Discount on Sessions"></dxo-label>
                        </dxi-item>               
                        <dxi-item itemType="empty"></dxi-item>
                        <dxi-item dataField="CourseDiscount" dataType="number" editorType="dxNumberBox" [editorOptions]="discountEditorOptions">
                            <dxo-label Text="% Discount on Courses"></dxo-label>
                        </dxi-item>               
                        <dxi-item itemType="empty"></dxi-item>
                    </dxi-tab>
                </dxi-item>
                <div *dxTemplate="let data of 'mobileTelephoneTemplate'" style="display: flex; flex-direction: row-reverse;">
                    <dx-text-box [(value)]="clientMobileDisplayValue" [placeholder]="country?.exampleNSN"
                        (onInput)="onMobileInput($event)">
                    </dx-text-box>
                    <dx-lookup [dataSource]="countries" valueExpr="this" itemTemplate="countryItemTemplate"
                        fieldTemplate="countryFieldTemplate" (onValueChanged)="onMobileISDSelected($event)" [searchExpr]="['name', 'prefixedISD']">
                        <dxo-drop-down-options [width]="450" [height]="500" [showTitle]="false" [toolbarItems]="[]">
                        </dxo-drop-down-options>
                        <div *dxTemplate="let data of 'countryFieldTemplate'">
                            +{{country?.ISD}}
                        </div>
                        <div *dxTemplate="let country of 'countryItemTemplate'">
                            <span [ngClass]="'fi fi-' + country?.ISO2.toLowerCase()"></span>
                            {{country?.name}}
                            +{{country?.ISD}}
                        </div>
                    </dx-lookup>
                </div>
                <div *dxTemplate="let data of 'clientPhotoTemplate'">
                    <div id="template-content">
                        <app-client-photo-upload [selectedClient]="this.client.Id" (photoUploaded)="togglePhotoUploaded($event)">
                        </app-client-photo-upload>
                    </div>
                </div>
            </dx-form>
        </dx-scroll-view>        
    </div>
</dx-popup>
